import React, { Fragment } from 'react';
import SaleStats from './SaleStats';
import Alert from './Alert';
import ActionOverviewGraph from './ActionOverview.Graph';
import { priceHistory } from '../../ChartData';
import { useSelector } from 'react-redux';

function InsightsSection() {
    const activeAlert = useSelector((state) => state.dropTrackProducts.droptrackProductPage.activeAlert.type);

    return (
        <>
            {activeAlert && <Alert />}

            <SaleStats />

            <div className="flex mt-3 mx-5">
                <ActionOverviewGraph 
                    actionOverviewData={priceHistory} 
                />
            </div>
        </>
    );
}

export default InsightsSection;
